import { TriageCategory } from '../../graphQL';

// Shared Beacon/SAI constants read by both the app-shared Beacon components here
// (ScoreBar, TriagePill, ComplexNeedsPill) and the SAI widgets under Pages/Users/Widgets.

// The upper bound the persistence/wellbeing indices are scored against. Fixed rather than
// per-run — the endpoint states it in the SaiStudentDetailIndices schema descriptions
// instead of serving it as a field — so both the detail panel and the list score bar read it here.
export const MAX_INDEX_SCORE = 100;

// One palette for both triage surfaces — the detail badge (marker text on white + a matrix
// cell tinted by activeColor) and the list pill (12px marker text on the activeColor tint).
// Every marker/active pair clears WCAG AA (4.5:1) as pill text, which the previous palette
// did not (Stable/Drifting/Strained failed at 12px).
export const TRIAGE_STABLE_MARKER_COLOR = '#2D6A62';
export const TRIAGE_STABLE_ACTIVE_COLOR = '#E5F4E4';
export const TRIAGE_DRIFTING_MARKER_COLOR = '#1E40AF';
export const TRIAGE_DRIFTING_ACTIVE_COLOR = '#E8EDFD';
export const TRIAGE_STRAINED_MARKER_COLOR = '#8A5A00';
export const TRIAGE_STRAINED_ACTIVE_COLOR = '#FFF8CC';
export const TRIAGE_HIGH_NEED_MARKER_COLOR = '#A9110F';
export const TRIAGE_HIGH_NEED_ACTIVE_COLOR = '#F8D1CE';

// Category → colours for the list pill (`TriagePill`), keyed on the enum. `markerColor`
// is the foreground (pill text); `activeColor` is the tint (pill background). The detail
// badge derives its own `CATEGORY_STYLES` from the scalar constants above, so the two
// share these values without reading this record. Only `CATEGORY_LABELS` is read by both.
export const CATEGORY_COLORS: Record<TriageCategory, { activeColor: string; markerColor: string }> =
  {
    Stable: { activeColor: TRIAGE_STABLE_ACTIVE_COLOR, markerColor: TRIAGE_STABLE_MARKER_COLOR },
    Drifting: {
      activeColor: TRIAGE_DRIFTING_ACTIVE_COLOR,
      markerColor: TRIAGE_DRIFTING_MARKER_COLOR,
    },
    Strained: {
      activeColor: TRIAGE_STRAINED_ACTIVE_COLOR,
      markerColor: TRIAGE_STRAINED_MARKER_COLOR,
    },
    HighNeed: {
      activeColor: TRIAGE_HIGH_NEED_ACTIVE_COLOR,
      markerColor: TRIAGE_HIGH_NEED_MARKER_COLOR,
    },
  };

// The staff-facing name for each category, keyed on the enum the API serves so that every surface
// naming one reads the same word, and typed as a total record so a category added to the enum stops
// the build here until it is named. Both surfaces that draw a category read this map.
export const CATEGORY_LABELS: Record<TriageCategory, string> = {
  HighNeed: 'High Need',
  Strained: 'Strained',
  Drifting: 'Drifting',
  Stable: 'Stable',
};
